import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row'
import Alert from 'react-bootstrap/Alert'

import "./styles.scss"


// A bottom navbar composed of the ResetButton, PrevButton, and NextButton
export default function CompletionBar({completed}) {
    const sourceStyle={
      marginTop:'10px',
      float:'left',
      color:'grey',
      fontSize:'12px'
    }

    return (
      
      <Row className="completion-row">
        {completed && <Alert className="completion-banner" aria-live="polite">
          <strong>Interactive complete.</strong>
        </Alert>
        }
      </Row>
    )
};

// NavBar.propTypes = {
//   onClickPrev: PropTypes.func,
//   onClickNext: PropTypes.func
// };
